import React from "react"
import Icon from "@kit/design/icon"

// This component is shown as the preview for a Product embed in the reorderable
// sidebar.

export function ProductEmbedPreview() {
  return (
    <div className="flex items-center">
      <div className="w-6 h-6 flex items-center justify-center mr-4">
        <Icon name="tag-money" />
      </div>
      <div>Product</div>
    </div>
  )
}
